/**
 * IconText — small inline icon + text (table meta lines, e.g. edition date).
 * `tone`: 'default' (primary text) | 'muted'.
 */
export default function IconText({ icon: Icon, children, tone = 'muted', className = '' }) {
  return (
    <span className={`icon-text icon-text--${tone} ${className}`.trim()}>
      {Icon && <Icon size={12} aria-hidden="true" />}
      {children}
    </span>
  );
}
